$( document ).ready(function() {
    var active_elements = 0;
    $( ".swatch-element input[type='radio']" ).each(function() {
        if($( this ).parent().hasClass('available')) {
            active_elements++;
            if(active_elements==1){
                $( this ).click();
            }
        }
    });

    var prod_quantity = $('#product_max_quantity').val()*1;

    if(active_elements == 0) {
        if(prod_quantity>0){

        }else {
            $('#buy_product').hide();
            $('#sold_out_product').show();
        }
    }

    $('.soldoutsize').on('click',function(){
        $('#buy_product').hide();
        $('#sold_out_product').show();
    });
    $('.availablesize').on('click',function(){
        $('#buy_product').show();
        $('#sold_out_product').hide();
        $('.icon-plus img').show();
        $('#product_selected_quantity').val(1)
    });

    $('.product-page-quantity-change').on('click', function () {

        var max_qty = 1;
        $('.swatch div.swatch-element input').each(function(i,elem) {
           if($(this).is(':checked')){
               max_qty = $(this).parent().data('max-quantity');
           }
        });

        var selected_qty = parseInt($('#product_selected_quantity').val());
        var new_qty = selected_qty;

        if ($(this).hasClass('icon-plus')) {
            if (max_qty > selected_qty) {
                new_qty++;
            }
        } else {
            if (new_qty > 1) {
                new_qty--;
            }
        }
        new_qty = (isNaN(new_qty)) ? 1 : new_qty;
        $('#product_selected_quantity').val(new_qty)

        if (max_qty == new_qty) {
            $('.icon-plus img').hide();
        } else {
            $('.icon-plus img').show();
        }
    });
});